import * as React from 'react'
import { classNames } from './helpers'

export interface LayoutContainerProps {
  children: React.ReactNode;
}

/** A centered, max-width page container with safe-area-aware horizontal padding. */
export function LayoutContainer ({ children }: LayoutContainerProps) {
  const classes = classNames('mlsg-layout-container')
  return <div className={classes}>{children}</div>
}
